import { useCallback } from 'react';
import { IStatus } from 'src/typings/complexes';
import { useDispatch, useSelector } from 'react-redux';
import { getView2dDisabledStatuses } from 'src/store/view-2d/selectors';
import { Actions } from 'src/store/view-2d/actions';
import { getCurrentLang } from 'src/store/app/selectors';
import { useBuildType } from 'src/hooks';

export const useCrosstableStatusToggle = () => {
  const currentLang = useSelector(getCurrentLang);
  const { isCrossTable } = useBuildType();
  const disabledStatusesList = useSelector(getView2dDisabledStatuses);
  const dispatch = useDispatch();
  const disableStatus = useCallback((status: IStatus) => {
    if (!isCrossTable) return;
    if (isStatusDisabled(status)) {
      const tmpList = [...disabledStatusesList];
      const index = tmpList.indexOf(status);
      if (index != -1) {
        tmpList.splice(index, 1);
        dispatch(Actions.setView2dDisabledStatuses(tmpList));
      }
    } else {
      dispatch(Actions.setView2dDisabledStatuses([...disabledStatusesList, status]));
    }
  }, [disabledStatusesList, isCrossTable]);

  const isStatusDisabled = useCallback((status: IStatus) => {
    return disabledStatusesList.includes(status);
  }, [disabledStatusesList]);

  const isStatusDisabledByStatusName = useCallback((statusName: string | null) => {
    if (!isCrossTable) return false;
    return disabledStatusesList.some((status) => {
      const property = 'crosstableName';
      return status[property][currentLang] === statusName;
    });
  }, [disabledStatusesList, currentLang, isCrossTable]);

  return {
    disabledStatusesList,
    disableStatus,
    isStatusDisabled,
    isStatusDisabledByStatusName,
  };
};
